import src from "IMAGE";
export default { src, width: 87, height: 21, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAA2GVsAPhxlAEEebQA9HGQAPh5vADcbXAA6G2AAOBtbAAAlETwALRZJADcaXgAsFUkANhlfACQROgAkEDoAJhM9YQ4KB8By7GMAAAAASUVORK5CYII="};
